import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import Chat from "./components/Chat/chat";
import SetUserInfo from "./components/SetUserInfo/SetUserInfo";


const basename =
  process.env.REACT_APP_BASE_PATH && process.env.REACT_APP_BASE_PATH !== "/"
    ? process.env.REACT_APP_BASE_PATH
    : "/";

export default class App extends React.Component {
    render() {
        //{position: 'absolute', bottom: 0, height: '100%', width:'99%'}
        return (
            <BrowserRouter basename={basename}>
                <Switch>
                    <Route exact path="/" component={SetUserInfo}/>
                    <Route path="/chat" component={Chat}/>
                    <Route path="/:roomId" component={SetUserInfo}/>
                    <Redirect to='/'/>
                </Switch>
            </BrowserRouter>
        )
    }
};
